import { cn } from '@ctct/summit-core';
import { type FlagProps } from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';

const Flag = ({ country, countryName, className }: FlagProps & { className?: string }) => {
  const FlagImage = flags[country];

  return (
    <span
      className={cn(
        "r:flex r:h-4 r:w-6 r:overflow-hidden r:rounded-xs r:bg-foreground/20 r:[&_svg:not([class*='size-'])]:size-full",
        className
      )}
    >
      {FlagImage && <FlagImage title={countryName} />}
    </span>
  );
};

export { Flag };
